/**
 * Sticky on Scroll
 *
 * Adiciona classe a um elemento quando seu top toca o topo da viewport.
 *
 * @param {string} elementQuery seletor do elemento.
 */
export default class StickyOnScroll {
    constructor(elementQuery) {
        this.toSticky = document.querySelector(elementQuery);

        this.toStickyInitialTop =
            this.toSticky.getBoundingClientRect().top + document.documentElement.scrollTop;

        addEventListener("scroll", () => {
            const scrollPosition = document.documentElement.scrollTop;

            if (scrollPosition >= this.toStickyInitialTop) {
                if (!this.toSticky.classList.contains("is-sticky")) {
                    this.toSticky.classList.add("is-sticky");
                }
            } else {
                this.toSticky.classList.remove("is-sticky");
            }
        });
    }
}
